import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import { InferResponseType } from "hono";
import { FilesQuery } from "./storageQueryProvider";
import { t } from "@/lib/localization";

export type GetFilesResponseType = InferResponseType<
    typeof client.api.storage.query.files.$get,
    200
>;

export const useGetFiles = (
    {
        page,
        resultsPerPage,
        search,
        sortBy,
        orderBy,
        filterBy,
        folderId,
    }: FilesQuery & { folderId?: string },
    options?: { enabled?: boolean }
) => {
    const query = useQuery({
        enabled: options?.enabled,
        queryKey: [
            "get-storage-files",
            {
                page,
                resultsPerPage,
                search,
                sortBy,
                orderBy,
                filterBy,
                folderId,
            },
        ],
        queryFn: async () => {
            const response = await client.api.storage.query.files.$get({
                query: {
                    page: page.toString(),
                    resultsPerPage: resultsPerPage.toString(),
                    search,
                    sortBy,
                    orderBy,
                    filterByType: filterBy,
                    folderId,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch files");
            }

            const { data, total } = await response.json();
            return { data, total };
        },
    });

    return query;
};
